import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { buildRoutesFromStructure } from 'modules/shared-navigation';
import { concatUrl } from '../../../shared/utils';
import { SubRouterProps, IdRouteParams } from '../../../shared/types';
import { Switch, NotFound } from '../../../shared/components';
import { GamePage, GameParticipationConfirmationPage } from '../../pages';
import { ContentSelector } from './components';

export const Router: React.FC<SubRouterProps> = (props: SubRouterProps) => {
    const { sourceStructureNode, navigationTree } = props;

    if (!sourceStructureNode || !sourceStructureNode.nodes || sourceStructureNode.nodes.length === 0) {
        return <React.Fragment />;
    }

    return (
        <Switch>
            <Route
                exact
                path={concatUrl([navigationTree.path, '/jeu/:id'])}
                render={(subProps: RouteComponentProps<IdRouteParams>) => {
                    const { id } = subProps.match.params;
                    return <GamePage id={id} filterParams={[{ key: 'id', value: id }]} />;
                }}
            />
            <Route
                exact
                path={concatUrl([navigationTree.path, '/jeu-participation-confirmee/:id'])}
                render={(subProps: RouteComponentProps<IdRouteParams>) => {
                    const { id } = subProps.match.params;
                    return <GameParticipationConfirmationPage id={id} filterParams={[{ key: 'id', value: id }]} />;
                }}
            />
            {buildRoutesFromStructure(
                ContentSelector,
                sourceStructureNode.nodes,
                navigationTree,
                undefined,
                true,
                true,
            )}
            <Route
                path={concatUrl([navigationTree.path, 'preview/:template/:id'])}
                render={(subProps: RouteComponentProps<IdRouteParams>) => {
                    return (
                        <ContentSelector
                            id={subProps.match.params.id}
                            template={subProps.match.params.template}
                            navigationTree={navigationTree}
                            sourceStructureNode={{}}
                        />
                    );
                }}
            />
            <Route component={NotFound} />
        </Switch>
    );
};
